import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TableDateFormatComponent } from "../table-date-format/table-date-format.component";
import { ValidationListTableComponent } from "../validation-list-table/validation-list-table.component";
@Component({
  selector: 'emi-table-control',
  standalone: true,
  imports: [TranslateModule, CommonModule, NgFor, NgIf, TooltipModule, MatIconModule, TableDateFormatComponent, ValidationListTableComponent],
  templateUrl: './table-control.component.html',
  styleUrls: ['./table-control.component.css']
})
export class TableControlComponent implements OnInit, OnChanges {
  @Input() tableData: Array<any> = [];
  @Output() action = new EventEmitter<any>();
  public dataInformation: Array<any> = [];
  constructor(private readonly translateService: TranslateService) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.dataInformation = this.tableData;
    console.log(this.dataInformation);
  }

  public actionEvent(event: any, data: any): void {
    this.action.emit({ event, data });
  }

  
}
